import React from 'react';
import { Target, Zap, Workflow, Code2 } from 'lucide-react';
import { motion } from 'framer-motion';
import { whyUsData } from '../data/mock';

const WhyUs = () => {
  const icons = [Target, Zap, Workflow, Code2];
  const accents = [
    'from-violet-600 to-purple-500',
    'from-fuchsia-600 to-pink-500',
    'from-sky-500 to-cyan-500',
    'from-emerald-500 to-teal-500'
  ];
  // Bento span pattern
  const spans = [
    'lg:col-span-8',
    'lg:col-span-4',
    'lg:col-span-4',
    'lg:col-span-8'
  ];

  return (
    <section
      id="why-us"
      data-testid="why-us-section"
      className="relative py-28 lg:py-36"
      style={{ backgroundColor: '#0e1629' }}
    >
      <div className="absolute inset-0 bg-grid bg-grid-fade opacity-30 pointer-events-none" />
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-fuchsia-600/10 blur-[160px] rounded-full pointer-events-none" />

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-14 lg:mb-16">
          <div className="max-w-2xl">
            <span className="inline-block text-xs font-bold uppercase tracking-[0.22em] text-fuchsia-300 mb-5">
              Miért a Boldigital?
            </span>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-[3.25rem] font-semibold text-white leading-[1.05] tracking-tight text-balance" data-testid="why-us-title">
              Partnerség, nem csak szolgáltatás
            </h2>
          </div>
          <p className="max-w-md text-slate-400 text-base lg:text-lg">
            Több mint webfejlesztés – mellettünk végigjárod az utat a megjelenéstől a stabil ügyfélszerzésig.
          </p>
        </div>

        {/* Bento Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-5 lg:gap-6">
          {whyUsData.map((item, index) => {
            const Icon = icons[index];
            return (
              <motion.div
                key={item.id}
                data-testid={`why-us-card-${item.id}`}
                initial={{ opacity: 0, y: 36 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: '-60px' }}
                transition={{ duration: 0.7, delay: index * 0.08, ease: [0.22, 1, 0.36, 1] }}
                className={`${spans[index]} group relative spotlight rounded-[1.75rem] bg-slate-50 ring-1 ring-slate-900/5 p-7 lg:p-9 overflow-hidden
                  shadow-[0_14px_40px_-18px_rgba(15,23,42,0.8)] hover:-translate-y-1.5 transition-all duration-500`}
              >
                <div className="grain-overlay" />
                <div className={`absolute -bottom-16 -right-10 w-52 h-52 rounded-full bg-gradient-to-br ${accents[index]} opacity-[0.10] blur-3xl group-hover:opacity-[0.22] transition-opacity duration-700`} />

                <div className="relative flex items-center gap-4 mb-6">
                  <div className={`w-12 h-12 rounded-xl bg-gradient-to-br ${accents[index]} flex items-center justify-center shadow-lg`}>
                    <Icon className="w-5 h-5 text-white" strokeWidth={2.3} />
                  </div>
                  <span className="text-xs font-bold uppercase tracking-widest text-slate-400">
                    0{item.id}
                  </span>
                </div>

                <h3 className="font-display text-xl lg:text-2xl font-semibold text-slate-900 tracking-tight mb-2.5">
                  {item.title}
                </h3>
                <p className="text-slate-600 leading-relaxed text-[15px] lg:text-base max-w-md">
                  {item.description}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyUs;
